import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import { List, Tag } from "antd";
import { useMessage } from "../MessageProvider/MessageProvider";
import { VscCopy } from "react-icons/vsc";
import TicketItem from "./TicketItem";
import "./Lists.css";

const ITEM_HEIGHT = 150;

export default function TicketList({ data, setSelected, selected }) {
  const messageApi = useMessage();

  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: "Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scrolling speed by changing multiplier
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    console.log(data);
  }, []);
  if (data) {
    return (
      <div
        ref={scrollContainerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        // max-w-[1200px]
        className={
          isDragging
            ? " pt-[8px] pl-[15px] overflow-auto  cursor-grabbing"
            : " pt-[8px] pl-[15px]  overflow-auto  cursor-pointer"
        }
      >
        {/* grid here.. */}
        <div className="wrapper_table">
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "1/3",

              textAlign: "center",
              verticalAlign: "middile",
              borderCollapse: "collapse",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            borderCollapse
          >
            <p className="p-0 m-0">1</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "1/3",

              textAlign: "center",
              verticalAlign: "middile",
              borderCollapse: "collapse",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            borderCollapse
          >
            <p className="p-0 m-0">Ваколатли омбор ёки шахобча</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridColumn: "3/5",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // justifySelf: "center",
              // alignSelf: "center",
            }}
          >
            <p className="p-0 m-0">ЎзРТХБ шартномаси</p>{" "}
          </div>
          <div
            style={{
              gridRow: "2/2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="border-[1px] border-[#000]"
          >
            <p className="text-center p-0 m-0 ">Шартнома №</p>{" "}
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">Санаси </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridColumn: "5/8",
              gridRow: "1/3",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">Юкни олувчи номи </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              // gridColumn: "7/8",
              gridRow: "1/3",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">СТИР </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridColumn: "9/11",
              gridRow: "1/1",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">Ишонч ваколати </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              // gridColumn: "7/8",
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">№ </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">Ишонч ваколати </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridColumn: "11/13",
              gridRow: "1/1",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">Махсулот транспорт юк хати </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0">Санаси </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">№</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "1/1",
              gridColumn: "13/17",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">Чиким килинган махсулот </p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">Номи</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">улч. Бирлиги</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">Микдори</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "2/2",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">Умумий киймати</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "1/3",
              // gridColumn: "16/17",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">Tek.sh</p>
          </div>
          <div
            className="border-[1px] border-[#000]"
            style={{
              gridRow: "1/3",
              // gridColumn: "16/17",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="p-0 m-0 text-center">?</p>
          </div>
        </div>
        <List
          height={window.innerHeight - 100} // Or any scrollable area height
          itemCount={data.length}
          itemSize={ITEM_HEIGHT}
          width={"100%"}
          itemData={{ data, selected, setSelected }}
        >
          {data?.map((el) => {
            return (
              <TicketItem
                isDragging={isDragging}
                data={data}
                selected={selected}
                el={el}
                setSelected={setSelected}
              />
            );
          })}
        </List>
      </div>
    );
  }
}
// naqtga = #86efac
// nasiya = #fb7185
// ticket = #fef08a
